var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* 申込人案件一覧 */
import React, { useState, useEffect } from 'react';
import 'gridjs/dist/theme/mermaid.css';
import { render } from 'react-dom';
import axios from '../axios';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { Modal, Button } from 'react-bootstrap';
import { overview_step_img, product_summary_link } from '../Const';
import { scrollPageTop } from '../Scroll';
import { jumpUrl } from '../Common';
var ProjectListApplicantImpl = function () {
    var _a = useState([]), projects = _a[0], setProjects = _a[1];
    var _b = useState(''), process_description_header = _b[0], setProcessDescriptionHeader = _b[1];
    var _c = useState(''), process_description_footer = _c[0], setProcessDescriptionFooter = _c[1];
    var _d = useState({
        disabled_project_detail_status: [],
    }), config = _d[0], setConfig = _d[1];
    var _e = useState(false), is_loading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), modal_show = _f[0], setModalShow = _f[1];
    var _g = useState(''), modal_message = _g[0], setModalMessage = _g[1];
    var _h = useState(true), opened_mypage = _h[0], setOpenedMypage = _h[1];
    // ご準備いただく書類ボタンのクリックベントを定義
    var handleDocumentsToPrepareClick = function () {
        var url = '#';
        window.open(url, '_blank');
    };
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getProject = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        return [4 /*yield*/, axios.get('/mypage/project/applicant')];
                    case 1:
                        response = _a.sent();
                        setProjects(response.data.reception_list);
                        setProcessDescriptionHeader(response.data.process_description_header);
                        setProcessDescriptionFooter(response.data.process_description_footer);
                        setConfig(response.data.config);
                        setOpenedMypage(response.data.opened_mypage);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        getProject();
    }, []);
    var images = [
        {
            //TODO degawa 差し替える画像の確認取れ次第変更
            src: overview_step_img,
            grid_system_class: 'col-xl-12 my-3',
        },
    ];
    var stepImageList = [];
    images.map(function (image, index) {
        stepImageList.push(React.createElement("div", { key: index, className: image.grid_system_class },
            React.createElement("img", { src: image.src, className: "img-fluid image-size-m" })));
    });
    /**
     * 案件一覧詳細画面へのハイパーリンクを生成する
     * @param id 受付ID
     * @param reception_cd 案件番号
     * @param status 案件ステータス
     */
    var makeHyperLink = function (id, reception_cd, status) {
        // リンクを非表示にする対象のステータスではない場合はハイパーリンクを生成する
        if (!config.disabled_project_detail_status.includes(Number(status))) {
            return (React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + reception_cd + "/" + id, onClick: function (event) {
                    return handleClickReception(event, id, reception_cd, status);
                } }, reception_cd));
        }
        return reception_cd;
    };
    /**
     * 案件番号のリンクをクリックする
     * @param event イベントオブジェクト
     * @param id 案件ID
     * @param r_cd 案件番号
     * @param status ステータス
     */
    var handleClickReception = function (event, id, r_cd, status) {
        event.preventDefault();
        setIsLoading(true);
        checkStatus(id, r_cd, status);
    };
    /**
     * 案件ステータスチェック
     * @param id 案件ID
     * @param r_cd 案件番号
     * @param status ステータス
     */
    var checkStatus = function (id, r_cd, status) { return __awaiter(void 0, void 0, void 0, function () {
        var response, exception_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post('/api/project/status/check', {
                            reception_cd: r_cd,
                            status: status,
                        })];
                case 1:
                    response = _a.sent();
                    if (response.data.result) {
                        // 遷移処理
                        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + r_cd + "/" + id;
                    }
                    else {
                        // エラーメッセージを表示
                        setIsLoading(false);
                        setModalMessage(response.data.message);
                        setModalShow(true);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    exception_1 = _a.sent();
                    jumpUrl(exception_1.response.data.url);
                    setIsLoading(false);
                    setModalMessage('案件ステータスが更新されています。案件を再度選択してください。');
                    setModalShow(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * モーダルを閉じる
     */
    var closeModal = function () {
        setModalShow(false);
        location.reload();
    };
    var projectsList = [];
    // 案件一覧を取得できた場合のみ案件一覧を生成する
    {
        projects.map(function (project, index) {
            projectsList.push(React.createElement("tr", { key: index },
                React.createElement("td", { className: "id" },
                    React.createElement("span", { className: "no" },
                        "No.",
                        index + 1),
                    React.createElement("span", { className: "id-body" }, makeHyperLink(project.id, project.reception_cd, project.status))),
                React.createElement("td", { className: "applicant_date" }, project.application_date),
                React.createElement("td", { className: "item" }, project.item),
                React.createElement("td", { className: "status" }, project.status_name)));
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row justify-content-md-center" },
                React.createElement("div", { className: "col-xl-12 my-3", dangerouslySetInnerHTML: { __html: process_description_header } })),
            projectsList.length > 0 && (
            // 案件一覧を取得できた
            React.createElement("div", { className: "project-list" },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "\u6848\u4EF6\u756A\u53F7"),
                            React.createElement("th", null, "\u304A\u7533\u8FBC\u307F\u65E5"),
                            React.createElement("th", null, "\u304A\u7533\u8FBC\u307F\u5546\u54C1"),
                            React.createElement("th", null, "\u72B6\u614B"))),
                    React.createElement("tbody", null, projectsList)))),
            opened_mypage ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "row justify-content-md-center" },
                    React.createElement("div", { className: "col-xl-12 my-3" },
                        React.createElement("div", { className: "d-flex justify-content-md-center" },
                            React.createElement("a", { className: "btn btn-main-color", onClick: handleDocumentsToPrepareClick }, "\u3054\u6E96\u5099\u3044\u305F\u3060\u304F\u66F8\u985E")))),
                React.createElement("div", { className: "row row-no-warap justify-content-md-center" },
                    React.createElement("div", { className: "col-xl-12 my-3", dangerouslySetInnerHTML: { __html: process_description_footer } })),
                React.createElement("div", { className: "row justify-content-md-center" },
                    React.createElement("div", { className: "col-xl-12 my-3" },
                        React.createElement("p", { className: "note" },
                            "\u30FB\u5404\u5546\u54C1\u306E\u6982\u8981\u306B\u3064\u3044\u3066\u306F",
                            React.createElement("a", { className: "link-text", target: "_blank", href: product_summary_link, rel: "noreferrer" }, "\u3053\u3061\u3089"),
                            "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
                        React.createElement("p", { className: "note" }, "\u30FB\u5BE9\u67FB\u306E\u7D50\u679C\u3001\u3054\u5E0C\u671B\u306B\u305D\u3048\u306A\u3044\u5834\u5408\u3082\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u4E88\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"),
                        React.createElement("p", { className: "note" }, "\u30FB\u4EEE\u5BE9\u67FB\u7D50\u679C\u306E\u6709\u52B9\u671F\u9650\u306F3\u30F5\u6708\u306B\u306A\u308A\u307E\u3059\u30023\u30F5\u6708\u4EE5\u5185\u306B\u6B63\u5F0F\u7533\u8FBC\u3092\u3044\u305F\u3060\u3051\u306A\u3044\u5834\u5408\u3001\u53D6\u4E0B\u3052\u3068\u306A\u308A\u307E\u3059\u306E\u3067\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"))))) : (React.createElement("div", { className: "row justify-content-md-center" },
                React.createElement("div", { className: "col-xl-12 my-3" },
                    React.createElement("p", { className: "note" }, "\u30FB\u304A\u624B\u7D9A\u304D\u306B\u3064\u3044\u3066\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u96FB\u8A71\u3067\u3054\u9023\u7D61\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002"),
                    React.createElement("p", { className: "note" },
                        "\u30FB\u5404\u5546\u54C1\u306E\u6982\u8981\u306B\u3064\u3044\u3066\u306F",
                        React.createElement("a", { target: "_blank", href: product_summary_link, rel: "noreferrer" }, "\u3053\u3061\u3089"),
                        "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
                    React.createElement("p", { className: "note" }, "\u30FB\u5BE9\u67FB\u306E\u7D50\u679C\u3001\u3054\u5E0C\u671B\u306B\u305D\u3048\u306A\u3044\u5834\u5408\u3082\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u4E88\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"),
                    React.createElement("p", { className: "note" }, "\u30FB\u4EEE\u5BE9\u67FB\u7D50\u679C\u306E\u6709\u52B9\u671F\u9650\u306F3\u30F5\u6708\u306B\u306A\u308A\u307E\u3059\u30023\u30F5\u6708\u4EE5\u5185\u306B\u6B63\u5F0F\u7533\u8FBC\u3092\u3044\u305F\u3060\u3051\u306A\u3044\u5834\u5408\u3001\u53D6\u4E0B\u3052\u3068\u306A\u308A\u307E\u3059\u306E\u3067\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"))))),
        React.createElement(LoadingModal, { show: is_loading }),
        React.createElement(Modal, { show: modal_show, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" }, modal_message),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: function () { return closeModal(); } }, "OK")))));
};
if (document.getElementById('project-list-applicant')) {
    render(React.createElement(ProjectListApplicantImpl, null), document.getElementById('project-list-applicant'));
}
